export var BrandResponsibility = function BrandResponsibility(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getDescription();
    }
  };
};
var brandResponsibilityBuilder = function brandResponsibilityBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "Dg58Ac",
        defaultMessage: "International shipping regulations"
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "hjwQzs",
        defaultMessage: "All brands selling on Faire are responsible for complying with all laws, rules, and regulations in all countries and regions they choose to sell their products in on Faire."
      }), strictLocalize({
        id: "ujgpuX",
        defaultMessage: "This includes but is not limited to: product safety, labeling requirements, testing, warnings, copyright, import/export regulations, and other consumer protection law requirements."
      }), strictLocalize({
        id: "DAIwfn",
        defaultMessage: "To determine if your products can be sold in other countries or regions, please consult a customs broker or legal counsel."
      })];
    }
  };
};